module.exports = __webpack_public_path__ + "img/20191221131827267.1ccacda5.jpg";